import { css } from "emotion";
import InputLabel from "./InputLabel";
import InputError from "./InputError";

const wrapperDiv = css({
  marginBottom: 12
});

const InputWrapper = ({ label, touched, error, required, children }) => {
  const errorClass = error ? "has-error" : "no-error";
  return (
    <div className={[wrapperDiv, errorClass].join(" ")}>
      <InputLabel label={label} />
      {children}
      <InputError touched={touched} error={error} />
    </div>
  );
};

export default InputWrapper;
